import { useState } from "react";

import {
  Bot,
  X,
  Send
} from "lucide-react";

import API
from "../services/api";

export default function CEOAIChatbot() {

  // =====================================
  // STATES
  // =====================================

  const [open, setOpen] =
    useState(false);

  const [message, setMessage] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [messages, setMessages] =
    useState([
      {
        role: "ai",

        text:
          "Hello CEO Sir 👋\nI am your Canon ERP AI Assistant.\nHow can I help you today?"
      }
    ]);

  // =====================================
  // SEND MESSAGE
  // =====================================

  const sendMessage =
    async () => {

      try {

        if (
          !message.trim()
        ) return;

        // =============================
        // USER MESSAGE
        // =============================

        const userMessage = {

          role: "user",

          text: message
        };

        // ADD USER MESSAGE
        setMessages(prev => [

          ...prev,

          userMessage,

          // TEMP AI MESSAGE
          {
            role: "ai",

            text:
              "Thinking..."
          }
        ]);

        const currentMessage =
          message;

        setMessage("");

        setLoading(true);

        // =============================
        // AI API
        // =============================

        const res =
          await API.post(
            "/ai/chat",
            {
              message:
                currentMessage
            }
          );

        // =============================
        // UPDATE AI RESPONSE
        // =============================

        setMessages(prev => {

          const updated =
            [...prev];

          // REPLACE LAST "Thinking..."
          updated[
            updated.length - 1
          ] = {

            role: "ai",

            text:

              res.data.reply ||

              "No response from AI"
          };

          return updated;
        });

      } catch (err) {

        console.log(err);

        // =============================
        // ERROR MESSAGE
        // =============================

        setMessages(prev => {

          const updated =
            [...prev];

          updated[
            updated.length - 1
          ] = {

            role: "ai",

            text:
              "AI server error"
          };

          return updated;
        });

      } finally {

        setLoading(false);
      }
    };

  // =====================================
  // UI
  // =====================================

  return (

    <>
      {/* =====================================
          FLOATING BUTTON
      ===================================== */}

      <button
        onClick={() =>
          setOpen(!open)
        }

        style={{

          position: "fixed",

          bottom: 25,

          right: 25,

          width: 65,

          height: 65,

          borderRadius: "50%",

          border: "none",

          background: "#1976d2",

          color: "#fff",

          cursor: "pointer",

          zIndex: 9999,

          boxShadow:
            "0 6px 18px rgba(0,0,0,0.25)"
        }}
      >

        {
          open

            ? <X size={28} />

            : <Bot size={28} />
        }

      </button>

      {/* =====================================
          CHAT WINDOW
      ===================================== */}

      {open && (

        <div
          style={{

            position: "fixed",

            bottom: 100,

            right: 25,

            width: 380,

            height: 580,

            background: "#fff",

            borderRadius: 20,

            boxShadow:
              "0 10px 35px rgba(0,0,0,0.2)",

            display: "flex",

            flexDirection: "column",

            overflow: "hidden",

            zIndex: 9999
          }}
        >

          {/* =====================================
              HEADER
          ===================================== */}

          <div
            style={{

              background: "#1976d2",

              color: "#fff",

              padding: 18,

              fontWeight: "bold",

              fontSize: 18
            }}
          >
            🤖 CEO AI Assistant
          </div>

          {/* =====================================
              CHAT MESSAGES
          ===================================== */}

          <div
            style={{

              flex: 1,

              padding: 15,

              overflowY: "auto",

              background: "#f5f7fb"
            }}
          >

            {messages.map(
              (msg, index) => (

                <div
                  key={index}

                  style={{

                    display: "flex",

                    justifyContent:

                      msg.role === "user"

                        ? "flex-end"

                        : "flex-start",

                    marginBottom: 12
                  }}
                >

                  <div
                    style={{

                      maxWidth: "80%",

                      padding:
                        "10px 14px",

                      borderRadius: 14,

                      whiteSpace:
                        "pre-wrap",

                      background:

                        msg.role === "user"

                          ? "#1976d2"

                          : "#fff",

                      color:

                        msg.role === "user"

                          ? "#fff"

                          : "#111",

                      boxShadow:
                        "0 2px 8px rgba(0,0,0,0.08)"
                    }}
                  >

                    {msg.text}

                  </div>

                </div>
              )
            )}

          </div>

          {/* =====================================
              INPUT AREA
          ===================================== */}

          <div
            style={{

              display: "flex",

              gap: 10,

              padding: 12,

              borderTop:
                "1px solid #eee"
            }}
          >

            <input
              value={message}

              disabled={loading}

              onChange={(e) =>
                setMessage(
                  e.target.value
                )
              }

              onKeyDown={(e) => {

                if (
                  e.key === "Enter"
                ) {

                  sendMessage();
                }
              }}

              placeholder="
Ask anything...
"

              style={{

                flex: 1,

                padding: 12,

                borderRadius: 12,

                border:
                  "1px solid #ddd",

                outline: "none"
              }}
            />

            <button
              onClick={sendMessage}

              disabled={loading}

              style={{

                width: 50,

                border: "none",

                borderRadius: 12,

                background: "#1976d2",

                color: "#fff",

                cursor: "pointer",

                opacity:
                  loading ? 0.7 : 1
              }}
            >

              <Send size={20} />

            </button>

          </div>

        </div>
      )}
    </>
  );
}